import { render, staticRenderFns } from "./EmptyCapture.vue?vue&type=template&id=4e975bab&scoped=true&"
import script from "./EmptyCapture.vue?vue&type=script&lang=js&"
export * from "./EmptyCapture.vue?vue&type=script&lang=js&"
import style0 from "./EmptyCapture.vue?vue&type=style&index=0&id=4e975bab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e975bab",
  null
  
)

export default component.exports